import HomePage from "@/views/HomePage.vue";

import { createRouter, createWebHistory } from "vue-router";
import { h, resolveComponent } from "vue";
import store from "@/store/store.js";
import { mdiConsoleNetworkOutline } from "@mdi/js";


const routes = [
  {
    path: "/",
    component: {
      render() {
        return h(resolveComponent("router-view"));
      },
    },
    meta: {
      title: "Documents",
      metaTags: [
        {
          name: "description",
          content: "Documents",
        },
        {
          property: "og:description",
          content: "Documents",
        },
      ],
    },
    children: [
      {
        path: "",
        name: "muzible",
        component: HomePage, // Login/Reg Screen only for not logged users, when user is logged and has some queryparam set redirect to that page
        meta: {
          title: "Documents",
          metaTags: [
            {
              name: "Documents",
              content: "Muzible - Solutions for Artists",
            },
            {
              property: "og:Documents",
              content: "Muzible - Solutions for Artists",
            },
          ],
        },
      },     
    ],
  },
  {
    path: "/:catchAll(.*)",
    redirect: "/",
  },
];

const router = createRouter({
  history: createWebHistory(),
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    window.scrollTo({ top: 0, behavior: "smooth" });
    return { left: 0, top: 0 };
  },
});

router.beforeEach((to, from, next) => {
    next();
});

export default router;
